module.exports = {
      id: "narrated-usage",
      viewBox: "0 0 32 19.2",
      url: "/" + "sprite-84df178c245af8be09420a4d0455d997.svg#narrated",
      toString: function () {
        return this.url;
      }
    }